export const STRINGS = {
    addPanelsMessage: 'Please add panels to this dashboard.',
    machineSrNo: 'MACHINE_SR_NO',
    dashboardTypeQuestion: 'Which type of dashbord you want to create?',
    explore: 'Explore',
    staticDashboard: 'Static Dashboard',
    dynamicDashboard: 'Dynamic Dashboard',
    downtimeDashboard: 'Downtime Dashboard',
    equipmentTemplateConfig: 'Equipment Template Configuration',
    configureDowntimeDashboard: 'Configure downtime dashboard',
    selectedFieldsData: 'Template selected fields data',
    configureDashboard:
        'Please configure and select the Equipment template and fields to see the report.',
    getReport: 'Get Report',
    noDowntimeFound: 'No downtime found for the selected machine sr number.',
    noPermission:
        'Sorry, you dont have enough  permissions to perform this action.',
    textConfig: 'Text Configuration',
    configuration: 'Configuration',
    heading: 'Heading',
    message: 'Message',
    textAlignment: 'Text Alignment',
    textColor: 'Text Color',
    backgroundColor: 'Background Color',
    imageConfig: 'Image Configuration',
    selectImage: 'Select Image',
    operation: 'Operation',
    unit: 'Unit',
    value: 'Value',
    linkButtonConfig: 'Link Button Configuration',
    buttonStyle: 'Button Style',
    linkConfig: 'Link',
    selectDashboard: 'Select Dashboard',
    linkType: 'Link Type',
    externalLink: 'External Link (URL)',
    styleConfig: 'Style',
    dataType: 'Data Type',
    gridConfig: 'Grid Config',
    pinterval: 'Interval',
    aggregation: 'Aggregate Functions',
    lineTypes: 'Line Types',
    intervalNAggregation: 'Interval and Aggregation',
    dataSource: 'Data Source',
    equipmentTemplate: 'Equipment Template',
    selectBarChartTags: 'Select Tags For Bar chart',
    selectLineChartTags: 'Select Tags For Line Chart',
    graphicsDashboard: 'Graphics Dashboard',
    graphicConfig: 'Graphics Configuration',
    configureGraphicsDashboard: 'Configure graphics dashboard',
    configureDashboardG:
        'Please configure and select the graphics file to see the result.',
    graphicFile: 'Graphic File',
    selectAssetId: 'Select Asset Ids',
    assetIds: 'Asset Ids',
    assetId: 'Asset Id',
    colorSetting: 'Color Settings',
    operator: 'Operator',
    color: 'Color',
    action: 'Action',
    noSchedule: 'No Schedule Available.',
    compare: 'Compare',
    text: 'Text',
    indicatorTagSelectMsg:
        'Please select tag for which you would like to show indicator.',
    paramsConfig: 'Params',
    tags: 'Tags',
    tag: 'Tag',
    tagsPlaceholder: '*_tag',
    tagParam: 'Tag Parameter e.g.(*_tagname)',
    addTag: 'Add Tag',
    noParamaterTagMsg: 'No Parameter Tags Added.',
    parameterisedTagConfiguration: 'Parameterised Tag Configuration :',
    generalConfiguration: 'General Configuration',
    parameterisedConfiguration: 'Parameterised Configuration',
    addBarChartTags: 'Add Tag For Bar chart',
    addLineChartTags: 'Add Tag For Line Chart',
    checkMore: 'Check More :',
    enterFormat: 'Enter Format',
    validFormat: 'Enter valid Format',
    dateConfig: 'Date Time Configuration',
    dateFormat: 'Date Format',
    format: 'dd/MM/yyyy hh:mm:ss a',
    alertTitle: 'Alert :',
    noParameterTagLinked:
        'This widget expects paramterised tag to be linked. Check the button configuration from where you navigated to this dashboard.',
    tagPrefix: 'Tag Prefix',
    symbol: 'Symbol',
    tagConfiguration: 'Tag Prefix Configuration',
    maxSymbolAlert: 'You can add maximum <arg0> symbols.',
    symbolNoTextAlert: 'Please specify the Symbol and Text for current row.',
    duplicateSymbolAlert: 'Symbol duplication is not allowed.',
    applyTagConfiguration: 'Apply Tag Configuration',
    expectedTag: 'Expected Target widget tag',
    reset: 'Reset',
    noTagConfigured: 'Tag configuration is not valid.',
    tagConfigurationApplied: 'Tag configuration applied successfully.',
    noalarmData: 'No Data Available',
    confirmAck: 'Are your sure to Acknowledge this Alarm?',
    priority: 'Priority',
    desc: 'Description',
    tagName: 'Tag Name',
    stat: 'Status',
    ack_stat: 'Ack Status',
    ack_by: 'Ack By',
    ack_at: 'Ack At',
    alarmConfig: 'Alarm Configuration',
    count: 'Count',
    acknowledged: 'Acknowledged',
    selectUnit: 'Select Units',
    units: 'Units',
    userEmail: 'User Email',
    getEvents: 'Get Events',
    userLog: ' User Log Event',
    all: 'ALL',
    date: 'Date Time',
    user: 'User',
    event: 'Event',
    ipAdd: 'IP Address',
    port: 'Port Number',
    export: 'Export',
    saveDashboard: 'Save Dashboard',
    import: 'Import',
    browse: 'Browse',
    home: 'Home',
    importJsonFile: 'Import dashboard JSON file.',
    invalidJson: 'Uploaded JSON is not valid',
    close: 'Close',
    searchDashboard: 'Search Dashboard...',
    noDashboardResult:
        'Dashboards not found with searched term. Please try with other keywords.',
    trends: 'Trends',
    dayWise: 'Day-Wise',
    interval: 'Interval',
    getTrend: 'Get Data',
    minValueError: 'Min always less then Max',
    maxValueError: 'Min & Max should not be equal',
    minMaxSettings: 'Min Max Setting',
    set: 'Set',
    verifyOtp: 'Verify OTP',
};

export default STRINGS;
